import styled from 'styled-components';

export const Wrapper = styled.div(
  props => `
    margin-top: 4rem;
`,
);

export const Title = styled.h2`
  font-size: 18px;
  font-family: 'Rubik';
  font-weight: 600;
`;

export const ContentWrapper = styled.div`
  background-color: rgb(255, 255, 255);
  border-radius: 12px;
  padding: 20px;
  margin-top: 2rem;
  
  .padB25 {
    padding-bottom: 25px;
  }
`;
export const Question = styled.div(
  props => `
        padding-bottom: 8px;
        h3 { 
          font-size: 16px;
          font-weight: 600;
        }
    `,
);
export const Answer = styled.div`
    font-size: 14px;
    color: #4f525a;
    ul {
      list-style-type: disc;
      padding: 1rem 0 0 2rem;

      li {
        padding: 0.5rem 0 0;
        padding-bottom: 0;

        &:last-child {
          padding-bottom: 0;
        }
      }
    }
`;